import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-analytics-charts/react-analytics-charts/node_modules/gatsby-theme-docz/src/base/Layout.js";
import BarChartPng from "../__docz__/images/BarChart.png";
import ColumnChartPng from "../__docz__/images/ColumnChart.png";
import GeoChartPng from "../__docz__/images/GeoChart.png";
import LineChartPng from "../__docz__/images/LineChart.png";
import PieChartPng from "../__docz__/images/PieChart.png";
import TableChartPng from "../__docz__/images/TableChart.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "charts-overview"
    }}>{`Charts Overview`}</h1>
    <p>{`For your convenience, you can choose from 10+ commonly used drop-in charts, or create your own data queries for `}<a parentName="p" {...{
        "href": "/react-analytics-charts/BarChart"
      }}>{`bar charts`}</a>{`,
`}<a parentName="p" {...{
        "href": "/react-analytics-charts/ColumnChart"
      }}>{`column charts`}</a>{`, `}<a parentName="p" {...{
        "href": "/react-analytics-charts/GeoChart"
      }}>{`geo charts`}</a>{`, `}<a parentName="p" {...{
        "href": "/react-analytics-charts/LineChart"
      }}>{`line charts`}</a>{`, `}<a parentName="p" {...{
        "href": "/react-analytics-charts/PieChart"
      }}>{`pie charts`}</a>{`, and `}<a parentName="p" {...{
        "href": "/react-analytics-charts/TableChart"
      }}>{`tables`}</a>{`.`}</p>
    <p>{`To use a chart, render it with an `}<a parentName="p" {...{
        "href": "/react-analytics-charts/AnalyticsDashboard"
      }}>{`AnalyticsDashboard`}</a>{`, which handles loading
the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`Google Analytics Embed API`}</a>{`,
`}<a parentName="p" {...{
        "href": "/react-analytics-charts/AuthorizeButton"
      }}>{`sign in`}</a>{` and `}<a parentName="p" {...{
        "href": "/react-analytics-charts/SignOutButton"
      }}>{`sign out`}</a>{`, and `}<a parentName="p" {...{
        "href": "/react-analytics-charts/ViewSelector"
      }}>{`view selection`}</a>{`. You can also embed `}<a parentName="p" {...{
        "href": "/react-analytics-charts/custom-dashboards-standalone-charts#standalone-charts"
      }}>{`standalone charts`}</a>{`.`}</p>
    <h2 {...{
      "id": "common-charts"
    }}>{`Common Charts`}</h2>
    <p>{`Choose from these pre-made charts for common queries:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/ActiveUsersChart"
        }}>{`ActiveUsersChart`}</a>{` - Visualize userbase growth over time.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/BounceRateChart"
        }}>{`BounceRateChart`}</a>{` - See how well a site grabs people's attention.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/OrganicSearchesChart"
        }}>{`OrganicSearchesChart`}</a>{` - Visualize traffic from organic searches.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/PageViewsPerPathChart"
        }}>{`PageViewsPerPathChart`}</a>{` - See which pages and posts are most popular.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/PagesPerSessionChart"
        }}>{`PagesPerSessionChart`}</a>{` - See how engaged users are.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionDurationChart"
        }}>{`SessionDurationChart`}</a>{` - Visualize how long users stay before leaving.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsByDateChart"
        }}>{`SessionsByDateChart`}</a>{` - See how traffic grows over time.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsByDeviceCategoryChart"
        }}>{`SessionsByDeviceCategoryChart`}</a>{` - See how users consume content.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsByHourChart"
        }}>{`SessionsByHourChart`}</a>{` - Know the best time to post content.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsBySourceChart"
        }}>{`SessionsBySourceChart`}</a>{` - See which sites traffic comes from.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsByUserTypeChart"
        }}>{`SessionsByUserTypeChart`}</a>{` - See the proportion of new and returning visitors.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-analytics-charts/SessionsGeoChart"
        }}>{`SessionsGeoChart`}</a>{` - Visualize where in the world visitors come from.`}</li>
    </ul>
    <p>{`See each chart for examples, information on usage, and the data queried by each.`}</p>
    <h2 {...{
      "id": "custom-charts"
    }}>{`Custom Charts`}</h2>
    <p>{`You can build your own charts if you want. Just choose from the following chart types:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/react-analytics-charts/BarChart"
          }}>{`BarChart`}</a>{` - A bar chart shows data as horizontal bars.`}</p>
        <img src={BarChartPng} />
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/react-analytics-charts/ColumnChart"
          }}>{`ColumnChart`}</a>{` - A column chart shows data as vertical bars.`}</p>
        <img src={ColumnChartPng} />
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/react-analytics-charts/GeoChart"
          }}>{`GeoChart`}</a>{` - A geo chart shows data on a map of the world.`}</p>
        <img src={GeoChartPng} />
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/react-analytics-charts/LineChart"
          }}>{`LineChart`}</a>{` - A line chart shows data as points connected by lines.`}</p>
        <img src={LineChartPng} />
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://justinmahar.github.io/react-analytics-charts/PieChart"
          }}>{`PieChart`}</a>{` - A pie chart shows data as slices of pie (or donut).`}</p>
        <img src={PieChartPng} />
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/react-analytics-charts/TableChart"
          }}>{`TableChart`}</a>{` - A table with rows of data under sortable labeled columns.`}</p>
        <img src={TableChartPng} />
      </li>
    </ul>
    <p>{`Just provide the chosen chart type with the `}<a parentName="p" {...{
        "href": "/react-analytics-charts/DataChart#query-prop"
      }}>{`data query`}</a>{` and optional chart options.`}</p>
    <p>{`See each chart type for examples and usage information.`}</p>
    <h3 {...{
      "id": "datachart"
    }}>{`DataChart`}</h3>
    <p>{`A `}<a parentName="p" {...{
        "href": "/react-analytics-charts/DataChart"
      }}>{`DataChart`}</a>{` is the base chart used by all of the above charts. It requires a
query and chart configuration, and uses the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`Google Analytics Embed API`}</a>{` to inject
the rendered chart into a container on the page.`}</p>
    <p>{`Each of the custom chart types above wraps `}<a parentName="p" {...{
        "href": "/react-analytics-charts/DataChart"
      }}>{`DataChart`}</a>{` and handles configuring the
chart prop of `}<a parentName="p" {...{
        "href": "/react-analytics-charts/DataChart"
      }}>{`DataChart`}</a>{` for you.`}</p>
    <p>{`You probably won't need to use a DataChart directly since all chart types are available as their
own components above, but you will definitely want to refer to the Query Prop section of
the `}<a parentName="p" {...{
        "href": "/react-analytics-charts/DataChart#query-prop"
      }}>{`DataChart documentation`}</a>{` for creating queries for any custom
charts you want to build.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      